import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse'

import {
    Chart,
    DoughnutController,
    BarElement,
    BarController,
    ArcElement,
    LineController,
    LineElement,
    Filler,
    PointElement,
    LinearScale,
    Title,
    Tooltip,
    Legend,
    CategoryScale
} from 'chart.js';

// GSAP
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";
import { gsapVerticalLoop } from "./gsapVerticalLoop";
import { gsapHorizontalLoop } from "./gsapHorizontalLoop";
import { inviewModule } from './inview';

// Swiper
import Swiper from 'swiper';
import { Autoplay, EffectFade, Pagination, Navigation } from 'swiper/modules';

// Components

// Register Chart.js components
Chart.register(
    DoughnutController,
    BarElement,
    BarController,
    ArcElement,
    LineController,
    LineElement,
    Filler,
    PointElement,
    LinearScale,
    Title,
    Tooltip,
    Legend,
    CategoryScale
);

inviewModule();

// GSAP Configuration
gsap.registerPlugin(ScrollTrigger, SplitText);
window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;
window.SplitText = SplitText;
window.gsapVerticalLoop = gsapVerticalLoop;
window.gsapHorizontalLoop = gsapHorizontalLoop;
window.inviewModule = inviewModule;

// Global
window.Alpine = Alpine;
window.Chart = Chart;


// Swiper
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

window.Swiper = Swiper;
Swiper.use([Autoplay, EffectFade, Pagination, Navigation]);

// Inits
Alpine.plugin(collapse);
Alpine.start();